import { Type } from 'class-transformer'

import { Client } from './Client'
import { User } from './User'

export class ClientUser extends User {
  static type = 'clientuser'
  type = ClientUser.type

  @Type(() => Client)
  client?: Client
}
